import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute } from "@tanstack/react-router"

import { SalesMobilePage } from "@/screens/Sales/components/SalesMobilePage"

export const Route: AnyRoute = createFileRoute("/app/tablet/sales/")({
  component: SalesMobilePage,
})
